import { DifficultyLevel } from "@src/helpers/difficultyLevelConstants";

export default [
  {
    title: "Piece of cake",
    difficulty: DifficultyLevel.EASY,
  },
  {
    title: "Live another day",
    difficulty: DifficultyLevel.AVERAGE,
  },
  {
    title: "Bring it on",
    difficulty: DifficultyLevel.HARD,
  },
  {
    title: "Nightmare",
    difficulty: DifficultyLevel.IMPOSSIBLE,
  },
];
